// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"456cb456","367":"b5d1288b","453":"4f112b71","815":"d401e271"}[chunkId] + ".chunk.js";
};